import { createSelector } from 'reselect';

export const selectCarbonEmission = (state) =>
  state.carbonReducer?.carbonEmission || {};

export const selectIsShowCarbon = createSelector(
  [selectCarbonEmission],
  (emission) => {
    const isEmpty = !Object.keys(emission).length;

    return !isEmpty;
  }
);
